// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

export default styled<any, Theme>('div')`
  > div:first-child {
    display: flex;

    > div {
      display: flex;
    }
  }
`;
